import React, { useEffect, useState } from 'react';

import { Button, Form, Row, Col, Spin, notification, Modal, message } from 'antd';
import TextBox from "../../components/ReportFormGenerator/TextBox/TextBox";
import { LoadingOutlined } from '@ant-design/icons';
import liracrypt from '../../components/Liracrypt/liracrypt';
import { getUrlCode } from '../../utils/CustomFunc';
import ZenModal from '../../components/ZenModal';
import StAddNew from '../DSeries/StAddNew';
import ApiErrorComp from '../../components/ApiErrorComp/ApiErrorComp';
import Scanter from '../../components/STORM/Scanter';

const ETrail = ({ selectedLid }) => {
    const [cursorOnBtn, setCursonOnBtn] = useState(false);
    const [loading, setLoading] = useState(true);
    const [scanter, setScanter] = useState();
    const [smodalForm] = Form.useForm();
    const [smodalConfig, setSmodalConfig] = useState();
    const [smodal, setSmodal] = useState({
        open: false,
        data: null
    });
    const [modal, setModal] = useState({
        type: "kanban",
        data: undefined,
        show: false,
        loading: false,
    });
    const [buttonAttr, setButtonAttr] = useState({
        className: 'scan-btn',
        text: 'Click To Scan'
    });
    const [scanResult, setScanResult] = useState(null);

    const [form] = Form.useForm();
    const [buttonLoading, setButtonLoading] = useState(false);

    const toggleModal = ({ show = false, data = undefined, type = type, loading = false }) => {
        setModal({ show, data, type, loading });
    }

    const closeSmodal = () => {
        setSmodal({
            open: false,
            data: null
        });
        smodalForm.resetFields();
    }

    const antIcon = (
        <LoadingOutlined style={{ fontSize: 30, color: "#fff" }} spin />
    );


    const onBlur = () => {
        if (!cursorOnBtn) {
            setButtonAttr({ ...buttonAttr, className: 'scan-btn', text: 'Click To Scan' });
            // setScanResult(null);
        };
    }

    const scanButton = () => {
        document.getElementById("scanter-barcode").focus();
        setButtonAttr({ ...buttonAttr, className: 'btn-scanned', text: 'Scan Part' });
    };

    // useEffect(() => {
    //     let focusOnInput = setInterval(() => {
    //         let element = document.activeElement;
    //         if (element.tagName.toLowerCase() !== 'input') {
    //             document.getElementById("inputterReport").focus();
    //         }
    //     }, 5000);
    //     return () => {
    //         clearInterval(focusOnInput);
    //     }
    // }, [buttonAttr]);

    const openNotificationWithIcon = (type, title, desc) => {
        notification[type]({
            message: title,
            description: desc ? desc : null,
        });
    };

    const openNewTab = ({ route }) => {
        route = `/v02/${getUrlCode()}${route}`;
        let urlData = { ...scanResult };
        urlData.lid = selectedLid;
        let searchParams = new URLSearchParams(urlData);
        route += `?${searchParams}`;
        console.log(route);
        window.open(route, '_blank');
    };

    const openKanban = () => {
        toggleModal({ show: true, loading: true, type: 'kanban' });
        liracrypt.get(`/textapi`, { dn: 'SingleKanban' }).then(response => {
            toggleModal({
                show: true,
                data: response?.data?.data,
                loading: false,
                type: 'kanban'
            })
        });
    }

    const scanOutput = scanResult && (
        <div className="scan-output">
            <p className="scan-heading" style={{ color: '#cdc9c7' }}>Last Scan Details:</p>
            <div className="scan-result">
                <span className="scan-result-key">ScanTime</span>
                <span>:</span>
                <span className="scan-result-value">{scanResult.time}</span>
            </div>
            <div className="scan-result">
                <span className="scan-result-key">Part No</span>
                <span>:</span>
                <span className="scan-result-value">{scanResult.data1}</span>
            </div>
            <div className="scan-result">
                <span className="scan-result-key">DateCode</span>
                <span>:</span>
                <span className="scan-result-value">{scanResult.data2}</span>
            </div>
            <div className="scan-result">
                <span className="scan-result-key">Counter No</span>
                <span>:</span>
                <span className="scan-result-value">{scanResult.data3}</span>
            </div>
            <div className="scan-result">
                <span className="scan-result-key">VendorCode</span>
                <span>:</span>
                <span className="scan-result-value">{scanResult.data4}</span>
            </div>
            <div className="scan-result-status">
                <span className="scan-result-key">Status</span>
                <span>:</span>
                <span style={{ color: scanResult.msgCol }} className="scan-result-value">{scanResult.msg}</span>
            </div>

            <Row style={{ marginTop: 20 }}>
                <Col span={24} style={{ display: 'flex', justifyContent: 'space-around' }}>
                    <Button
                        size='large'
                        type="primary"
                        onClick={() => openNewTab({ route: '/rt/EtrailMicroBom/b' })}>BOM</Button>
                    <Button
                        size='large'
                        type="primary"
                        onClick={() => openNewTab({ route: '/rt/EtrailLineStock/b' })}>LineStock</Button>
                    <Button
                        type="primary"
                        size='large'
                        onClick={() => openKanban({ route: '/lineperformance' })}
                    >ScanInfo</Button>
                </Col>
            </Row>
        </div>
    );


    useEffect(() => {
        setLoading(true);
        liracrypt.get('/textapi', { dn: 'Etrail' })
            .then(({ data }) => {
                if (data.isSuccess) {
                    setScanter(data.config.scanter);
                    setLoading(false);
                } else {
                    message.error(data.message || 'Something went wrong');
                }
            })
            .catch(err => {
                console.log(err);
                ApiErrorComp();
            })
    }, []);

    const smodalSubmit = (values) => {
        if (!smodalConfig?.url) {
            return;
        }
        setButtonLoading(true);
        let urlData = { ...smodalConfig?.params, ...values, ...smodal.data }
        if (smodalConfig?.method === 'POST') {
            liracrypt.post(smodalConfig?.url, { ...urlData })
                .then(({ data }) => {
                    if (data.isSuccess) {
                        setScanResult(data.data);
                        setButtonLoading(false);
                        openNotificationWithIcon("success", data.message);
                        closeSmodal();
                    } else {
                        openNotificationWithIcon("error", data.message);
                        setButtonLoading(false);
                        closeSmodal();
                    }
                }).catch(err => {
                    setButtonLoading(false);
                    ApiErrorComp();
                    console.log(err);
                })
        }
        if (smodalConfig?.method === 'PATCH') {
            liracrypt.patch(smodalConfig?.url, { ...urlData })
                .then(({ data }) => {
                    if (data.isSuccess) {
                        setScanResult(data.data);
                        setButtonLoading(false);
                        openNotificationWithIcon("success", data.message);
                        closeSmodal();
                    } else {
                        openNotificationWithIcon("error", data.message);
                        setButtonLoading(false);
                        closeSmodal();
                    }
                }).catch(err => {
                    setButtonLoading(false);
                    ApiErrorComp();
                    console.log(err);
                })
        }
        if (smodalConfig?.method === 'GET') {
            liracrypt.get(smodalConfig?.url, { ...urlData })
                .then(({ data }) => {
                    if (data.isSuccess) {
                        setScanResult(data.data);
                        setButtonLoading(false);
                        openNotificationWithIcon("success", data.message);
                        closeSmodal();
                    } else {
                        openNotificationWithIcon("error", data.message);
                        setButtonLoading(false);
                        closeSmodal();
                    }
                }).catch(err => {
                    setButtonLoading(false);
                    ApiErrorComp();
                    console.log(err);
                })
        }

    }

    const onFinish = (values) => {
        form.resetFields();
        let scanText = values.barCode;
        scanButton();
        if (scanText.substring(0, 3)?.toLowerCase() === 'cmd') {
            setSmodal({
                open: true,
                data: { custom: true, txt: scanText, lid: selectedLid }
            });
            return;
        }
        setButtonLoading(true);
        liracrypt
            .post(scanter?.submitFormDataProp?.url, {
                ...scanter?.submitFormData?.params,
                lid: selectedLid,
                txt: scanText,
            })
            .then((res, req) => {
                if (res.data.data) {
                    if (res.data.isSuccess) {
                        if (res.data.data) {
                            setScanResult(res.data.data);
                            setButtonLoading(false);
                            openNotificationWithIcon("success", res.data.data.msg);
                        } else {
                            openNotificationWithIcon("error", res.data.data.msg);
                            setButtonLoading(false);
                        }
                    } else {
                        openNotificationWithIcon("error", res.data.message);
                        setButtonLoading(false);
                    }
                } else {
                    openNotificationWithIcon("error", res.data.message);
                    setButtonLoading(false);
                }
            })
            .catch((err) => {
                setButtonLoading(false);
                ApiErrorComp();
                if (err.response !== undefined) {
                    if (err.response.status !== 401) {
                        // ApiErrorComp(err.response.status);
                    } else {
                        // setLoginError(true);
                    }
                }
            });
    };

    return (
        <div className="linedashboard-scanpart">
            {
                loading ?
                    <div className='loader'>
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 20 }} />} />
                    </div> :
                    <>
                        <div
                            onMouseOver={
                                () => setCursonOnBtn(true)
                            }
                            onMouseOut={
                                () => setCursonOnBtn(false)
                            }
                            onClick={scanButton}
                            className={`linedashboard-scan-btn ${buttonAttr.className}`}>
                            {buttonAttr.text}
                        </div>
                        <div style={{ width: '100%', marginTop: 10 }}>
                            <Scanter
                                onBlur={onBlur}
                                onFocus={scanButton}
                                onFinish={onFinish}
                                postSubmitAction={() => { }}
                                openPopupModal={() => { }}
                                button={scanter}
                                // setSelectedButton={setSelectedButton}
                                form={null}
                                label={scanter?.buttonProp?.label}
                                type={scanter?.buttonProp?.type}
                                disabled={!scanter?.buttonProp?.enable}
                                confirmationPopUp={scanter?.buttonProp?.confirmationPopUp ? scanter?.confirmationPopUpProp : undefined}
                                submitFormData={scanter?.submitFormDataProp}
                            />
                        </div>
                        {/* <div className="ThemeForm">
                <Form
                    name="ReportForm"
                    form={form}
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    layout="horizontal"
                    colon={false}
                    onFinish={onFinish}
                    size="large"
                >
                    <Row gutter={24} justify="center">
                        <Col span={22}>
                            <TextBox
                                onFocus={scanButton}
                                onBlur={onBlur}
                                form={form}
                                id="inputterReport"
                                type="input"
                                name="text"
                                label="Scan Text"
                                required={true}
                                errorMessage="Please Enter Text"
                                maxChar={20}
                                maxCharErrorMessage="Accepted only 20 Chars"
                            />
                        </Col>
                        <Col>
                            <Button
                                onMouseOver={
                                    () => setCursonOnBtn(true)
                                }
                                onMouseOut={
                                    () => setCursonOnBtn(false)
                                }
                                type="primary"
                                size="large"
                                style={{
                                    fontWeight: 600,
                                    width: "100%",
                                }}
                                htmlType="submit"
                            >
                                {buttonLoading ? <Spin indicator={antIcon} /> : "OK"}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div> */}
                        {scanOutput}
                        {
                            smodal.open ? (
                                <Modal width={'60%'} maskClosable={false} cancelButtonProps={{ hidden: true }} okButtonProps={{ hidden: true }} open={smodal.open} title={smodalConfig?.pageTitle || 'Scan Code'} onCancel={closeSmodal}>
                                    <>
                                        <StAddNew
                                            urlMethod={"GET"}
                                            setSmodalConfig={setSmodalConfig}
                                            formName="ScanPart"
                                            setSmodalTitle={title => { console.log(title) }}
                                            initForm={smodalForm}
                                            colSpan={24}
                                            urlEndpoint={'/smodal'}
                                            urlData={{ ...smodal.data }}
                                            onFormSubmit={smodalSubmit}
                                        />
                                        <div style={{ width: '100%', justifyContent: 'center', display: 'inline-flex' }}>
                                            <Button loading={buttonLoading} htmlType='submit' type="primary" form={'ScanPart'}>Submit</Button>
                                        </div>
                                    </>
                                </Modal>
                            ) : <></>
                        }

                        <ZenModal modal={modal} toggleModal={toggleModal} zenModal={{
                            title: 'Kanban Card',
                            width: '35%'
                        }} />
                    </>
            }


        </div>
    )
};

export default ETrail;